/*eslint-disable*/
import api from '../'

class ClassificationGameApi {
  // GET: items
  static getGameItems (params) {
    return api.axios.get('/classifications/matrix', { params }).then(response => response.data.matrix);
  }

  static getGroups (locale) {
    return api.axios.get('/classifications/groups', { params: { locale }}).then(response => response.data);
  }
}

export default ClassificationGameApi;
